import type { VSelectItem } from '../types/vuetify'

/**
 * Given an object (such as an enum), converts it to the format expected by
 * <v-select :items>.
 */
export default function objectToItems(obj: any): VSelectItem {
  return Object.entries(obj).map(([key, value]) => {
    return {title: value, value: key}
  })
}
